export default (component) => {
  window.RightSidebar.showComponent(component);
};
